import clsx from 'clsx';
import React from 'react';

import { useAppContext } from '@contexts/AppContext';
import { CORPORATE_EMAIL_ADDRESS } from '@utils/constants';
import { getImgxSrc } from '@utils/images';

import CorporateLeadForm, { LeadTypes } from './CorporateLeadForm';
import styles from './styles.module.scss';

const HeaderSection = () => {
  const { env } = useAppContext();

  return (
    <div className={styles.topContainer} id="topContainer">
      <div className={clsx(styles.headerWrapper, 'container')}>
        <div className={clsx(styles.headerContainer, 'row')}>
          <div className="col-sm-12 col-md-6">
            <div className={styles.tag}>Team opportunity</div>
            <div className={styles.header}>Group Subscriptions</div>
            <div className={styles.description}>
              The Information offers essential, original journalism on Silicon Valley and its impact
              on the world.
            </div>
            <div className={styles.heroImg}>
              <img
                src={getImgxSrc({
                  path: 'corporate/Hero.png',
                  isDevDependence: true,
                  envContext: env,
                })}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-6 mb-32">
            <CorporateLeadForm
              className="p-24"
              getInTouchEmailAddress={CORPORATE_EMAIL_ADDRESS}
              includeNumberOfUsers={true}
              leadType={LeadTypes.Corporate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
